import React, { useState, useEffect, useContext } from 'react';
import { emphasize, styled } from '@mui/material/styles';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Chip from '@mui/material/Chip';
import HomeIcon from '@mui/icons-material/Home';
import { useLocation, useNavigate } from 'react-router-dom';
import { UserContext } from '../assets/contexts/userContext';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

// Mapear segmentos de la ruta a nombres traducidos
const breadcrumbNames = {
  adminDashboard: 'Panel Admin',
  employeeDashboard: 'Panel Empleado',
  profile: 'Perfil',
  roles: 'Roles',
  calendar: 'Calendario',
  registro: 'Registrar usuario',
  usuarios: 'Usuarios',
  manageMedia: 'Gestión Multimedia',
  createForm: 'Crear Formulario',
  manageForms: 'Gestionar Formularios',
  createArticle: 'Crear Artículo',
  manageArticles: 'Gestionar Artículos',
  createClient: 'Crear Cliente',
  manageClients: 'Gestionar Clientes',
  createReport: 'Crear Informe',
  manageReports: 'Gestionar Informes',
  createService: 'Crear Servicio',
  manageServices: 'Gestionar Servicios',
  manageFormations: 'Gestionar Formaciones',
  formResponses: 'Respuestas Formulario',
  clinicalHistory: 'Historia Clínica',
  citas: 'Mis Citas',
  clientes: 'Gestionar Clientes',
  forms: 'Gestionar Formularios',
  articles: 'Gestionar Artículos',
  reports: 'Gestionar Informes',
  blog: 'Blog',
  services: 'Gestionar Servicios',
  categories: 'Gestionar Categorías',
  manageCategories: 'Gestionar Categorías',
  crear: 'Crear',
  editar: 'Editar',
};

const createEditEntities = {
  createClient: 'Cliente',
  createReport: 'Informe',
  createService: 'Servicio',
  createCategory: 'Categoría',
  createForm: 'Formulario',
};

const editSegmentEntities = {
  usuarios: 'Usuario',
  roles: 'Rol',
  blog: 'Artículo',
};

const createSegmentEntities = {
  roles: 'Rol',
};

const StyledBreadcrumb = styled(Chip)(({ theme }) => { 
  const backgroundColor =
     theme.palette.mode === 'light'
       ? theme.palette.grey[200]
       : theme.palette.grey[800];
      
  return {

    backgroundColor,
    // height: theme.spacing(2),
    height: 'min-content',
    borderRadius: '0.3em',
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover, &:focus': {
      backgroundColor: emphasize(backgroundColor, 0.2),
      color: '#ffffff',
      cursor: 'pointer',     
    },
    '&:active': {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
});

const Migas = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const [breadcrumbTrail, setBreadcrumbTrail] = useState([]);

  useEffect(() => {
    const pathArray = location.pathname.split('/').filter((x) => x);

    const isAdmin = user.hasRole && user.hasRole('admin');
    const isEmployee = user.hasRole && user.hasRole('employee');

    const basePath = isAdmin
      ? '/admin/adminDashboard'
      : isEmployee
        ? '/employee/employeeDashboard'
        : '/';

    const trail = [
      {
        path: basePath,
        breadcrumb: isAdmin
          ? breadcrumbNames.adminDashboard
          : isEmployee
            ? breadcrumbNames.employeeDashboard
            : 'Inicio',
      },
    ];

    let currentPath = '';
    const skipSegments = ['admin', 'employee'];

    pathArray.forEach((segment, index) => {
      currentPath += `/${segment}`;

      // avoid adding adminDashboard/employeeDashboard again
      if (segment === 'adminDashboard' || segment === 'employeeDashboard') return;

      // hide numeric ids from the breadcrumb trail
      if (/^\d+$/.test(segment)) {
        if (trail.length) trail[trail.length - 1].path = currentPath;
        return;
      }

      // skip segments like 'admin', 'employee' but keep the path for correct navigation
      if (skipSegments.includes(segment)) return;
      if (segment === 'pages') return; // keep in path but don't show in breadcrumb

      const nextSegment = pathArray[index + 1];
      const previousSegment = pathArray[index - 1];

      let breadcrumb =
        breadcrumbNames[segment] ||
        segment.charAt(0).toUpperCase() + segment.slice(1);

      if (createEditEntities[segment]) {
        const entity = createEditEntities[segment];
        const isEditing = nextSegment && /^\d+$/.test(nextSegment);
        breadcrumb = `${isEditing ? 'Editar' : 'Crear'} ${entity}`;
      } else if (segment === 'editar') {
        const entity = editSegmentEntities[previousSegment];
        breadcrumb = entity ? `Editar ${entity}` : 'Editar';
      } else if (segment === 'crear') {
        const entity = createSegmentEntities[previousSegment];
        breadcrumb = entity ? `Crear ${entity}` : 'Crear';
      }

      trail.push({ path: currentPath, breadcrumb });
    });

    setBreadcrumbTrail(trail);
  }, [location.pathname, user]);

  return (
    <div role="presentation">
      <Breadcrumbs
        sx={{
          display: 'flex',
          backgroundColor: 'transparent',
          mt: 2,
          mb: 3,
          px: 2,
          position: 'relative',
          zIndex: 3,
        }}
        aria-label="breadcrumb"
        separator={<NavigateNextIcon fontSize="small" />}
      >
        {breadcrumbTrail.map((item, index) => (
          <StyledBreadcrumb
            // sx={{ ml: 1 }}
            key={index}
            component="a"
            onClick={() => navigate(item.path)}
            label={item.breadcrumb}
            icon={item.path === '/' ? <HomeIcon fontSize="small" /> : null}
          />
        ))}
      </Breadcrumbs>
    </div>
  );
};

export default Migas;
